import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { ROLES } from '../../constants/roles';
import { PHARMACIST_PATHS, pharmacistNavItemsForRole } from './pharmacyPaths';
import { PHARMACY_COPY } from './pharmacyCopy';
import PharmacyPortalShell from './PharmacyPortalShell';

export default function PharmacistLayout() {
  const { user } = useAuth();
  return (
    <PharmacyPortalShell
      mode="site"
      allowedRoles={[ROLES.PHARMACIST]}
      navItems={pharmacistNavItemsForRole(user?.role)}
      dashboardPath={PHARMACIST_PATHS.DASHBOARD}
      dispensationPath={PHARMACIST_PATHS.DISPENSATION_NEW}
      brandSection={PHARMACY_COPY.LAYOUT.TOPBAR_SECTION_SITE}
      tagline={PHARMACY_COPY.LAYOUT.TOPBAR_TAGLINE_SITE}
      sideMenuTitle={PHARMACY_COPY.LAYOUT.SIDE_MENU_SECTION_SITE}
    />
  );
}
